import AxiosHttpClient from "../../application/services/axios-http-client";

export function makeAxiosHttpClient() {
  return new AxiosHttpClient();
}
